import { useWatch } from 'react-hook-form';

export const useWatchCheckedLinksCount = ({ name, control }) => {
  const watchedCheckedLinkIds = useWatch({ name, control });
  const checkedLinksCount = Object.values(watchedCheckedLinkIds).filter(
    Boolean
  ).length;
  return checkedLinksCount;
};
